import { round } from 'lodash-es'

export function numberWithCommas(num: number) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, function (txt: string) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

export const updateGasLabels = (text?: string) =>
  text?.includes('gas.') || text?.includes('invalid') || text?.includes('unknown') ? 'Gas API' : text

const ONE_MILLION = 1_000_000
export const displayAsMillions = (input: number) => `${(input / ONE_MILLION).toFixed()} Million`

const ONE_THOUSAND = 1_000
export const displayAsThousands = (value: number) => {
  if (value < ONE_THOUSAND) {
    return value
  }
  const valueInThousands = round(value / ONE_THOUSAND, 1)
  return `${valueInThousands}K`
}
